<div class="full-width page-padding" fxLayout="column" fxLayoutGap="20px" fxFlexOffset="30px">
  <div fxFlexOffset="20px">
    <div fxLayout="row" fxLayoutGap="20px">
      <span class="subtitle-default">Results</span>
      <button class="button-action" mat-flat-button
              (click)="refreshResponseData()"
              [disabled]="loader.loading$ | async">
        <div class="button-text">Refresh</div>
      </button>
    </div>
  </div>

  <div class="info-card" fxLayout="column">
    <span class="mat-body-1">Select a field to group the results. Questions that have multiple choices can be used to group the survey results</span>
    <mat-form-field class="custom-select-field" appearance="outline" floatLabel="always"
                    style="min-width: 240px; max-width: 650px; width: 100%">
      <mat-label>Group results by</mat-label>
      <mat-select class="custom-select-field-value" [(value)]="selectedGroupByField"
                  (valueChange)="updatedGroupResults()">
        <mat-option class="custom-select-field-option" *ngFor="let opt of groupByFieldOptions" [value]="opt.code">
          {{ opt.label }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <div fxLayout="column" fxLayoutGap="20px">
    @for (qs of displayedQuestions(); track qs) {
      @if (selectedGroupByField == 'ALL' || groupedControlTypes.includes(qs.controlType)) {
        <div class="question-card btn-cursor ps-0" fxLayout="row">
          <div class="question-card-left" fxLayout="column" fxLayoutAlign="center start">
            <mat-icon class="more-icon">more_vert</mat-icon>
          </div>

          <div class="full-width" fxLayout="column" fxLayoutGap="15px">
            <div class="question-card-header pb-2" fxLayout="row" fxLayoutAlign="space-between center">
              <div>
                <mat-form-field class="custom-select-field-borderless" appearance="outline" fxLayoutGap="5px">
                  <div class="select-icon me-2" matPrefix>
                    <mat-icon [svgIcon]="controlIcon(qs.controlType)"></mat-icon>
                  </div>
                  <mat-select [value]="qs.controlType" [disabled]="true">
                    <mat-option *ngFor="let comp of controlTypes" [value]="comp.controlType">
                      <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="15px">
                        <div class="select-icon">
                          <mat-icon [svgIcon]="comp.icon"></mat-icon>
                        </div>
                        <div class="body-1-default">{{ comp.label }}</div>
                      </div>
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="20px">
                <div class="body-1-regular-2">Total responses</div>
                <div>
                  <span class="app-form-title-chip" [matBadge]="qs.totalResponses" matBadgeColor="primary"></span>
                </div>
              </div>
            </div>

            <div fxLayout="column" fxLayoutGap="10px">
              <pre class="heading-bold">{{ qs.questionText }}</pre>

              @if (selectedGroupByField == 'ALL' || qs.questionCode == selectedGroupByField) {
                <div>
                  @if (!groupedControlTypes.includes(qs.controlType)) {
                    <div fxLayout="column" fxLayoutGap="10px">
                      @for (option of getPaginatedOptions(qs.questionCode); track option) {
                        <mat-form-field class="custom-text-field-full-width form-input-field" appearance="outline">
                          <input matInput placeholder="Enter your answer" [value]="option.optionText" readonly>
                        </mat-form-field>
                      }

                      <mat-paginator [length]="getLength(qs.questionCode)"
                                     [pageSize]="pageSize"
                                     [pageIndex]="paginatorMap.get(qs.questionCode)!.pageIndex"
                                     (page)="onPageChange($event, qs.questionCode)">
                      </mat-paginator>
                    </div>
                  }

                  @if (groupedControlTypes.includes(qs.controlType)) {
                    <div>
                      <div fxLayout="column" fxLayoutGap="10px">
                        @for (bar of ratingBars(qs.options, qs.totalResponses, qs.controlType); track bar) {
                          <div class="rating-bar-container">
                            <div class="rating-bar"
                                 [ngStyle]="{'width': bar.value + '%', 'background-color': bar.color}"></div>
                            <div class="rating-bar-text ps-3" fxLayout="row" fxLayoutGap="40px">
                              <span>{{ bar.value }}%</span>
                              <span [innerHTML]="bar.label"></span>
                            </div>
                          </div>
                        }
                      </div>
                    </div>
                  }
                </div>
              } @else {
                @if (groupedControlTypes.includes(qs.controlType) && qs.questionCode != selectedGroupByField) {
                  <div class="full-width" fxLayout="row" fxLayoutGap="10px">
                    <!--                get all available option for selected group-->
                    @for (option of groupOptions; track option) {
                      <div class="full-width" fxLayout="column" fxLayoutGap="10px" [fxFlex]="groupOptions.length != 0 ? 100 / groupOptions.length: 100">
                        <pre class="heading-bold">{{ option.optionText }}</pre>
                        <!--                get question stats map for the option code for iteration-->
                        <div fxLayout="column" fxLayoutGap="10px"
                             *ngIf="submissionStatGroupMap.get(option.optionCode); let optionStats">
                          <!--                get question stat for question in iteration-->
                          <ng-container *ngIf="optionStats.get(qs.questionCode); let groupedQs">
                            @for (bar of ratingBars(groupedQs.options, groupedQs.totalResponses, groupedQs.controlType); track bar) {
                              <div class="rating-bar-container">
                                <div class="rating-bar"
                                     [ngStyle]="{'width': bar.value + '%', 'background-color': bar.color}"></div>
                                <div class="rating-bar-text ps-3" fxLayout="row" fxLayoutGap="40px">
                                  <span>{{ bar.value }}%</span>
                                  <span [innerHTML]="bar.label"></span>
                                </div>
                              </div>
                            }
                          </ng-container>
                        </div>
                      </div>
                    }
                  </div>
                }
              }

            </div>

          </div>
        </div>
      }
    }

  </div>


</div>
